/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GlossaryInputs */



/**
* | output |
* | --- |
* | "Glossary" |
*
* @param {Nav_GlossaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_glossary = /** @type {((inputs?: Nav_GlossaryInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GlossaryInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Glossar")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glossaire")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("术语表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("詞彙表")
	if (locale === "ko") return /** @type {LocalizedString} */ ("용어집")
	return /** @type {LocalizedString} */ ("Glossary")
});